import React, { useEffect, useRef } from "react";
import SidePanel from "../../components/SidePanel";
import ModerationVisitPanel from "../../components/ModerationVisitPanel";
import { useSubject } from "../../context/SubjectContext";
import { useCenter } from "../../context/CenterContext";
import { useApi } from "../../context/ApiClient";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import { getCenterType, getRegistrationStatus } from "../../utils/utils";
import { normalizeVisitArrangementStatus } from "../../utils/normalizeVisitArrangementStatus";

const SubjectDashboardPage = () => {

  const { subjectData, setSubjectData, setLoading } = useSubject();
  
  const { selectedSubject, selectedSubjectCode, selectedSubjectId} =
    subjectData || {};
    
 const { centerNumber } = useCenter();
  const { consortiaCentres } = useConsortiaCenter()
  const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber),  selectedSubject, selectedSubjectId) || '';

const isRegistrationSuccess= getRegistrationStatus(currentCentreType, subjectData?.subjectDetails);

  const mountedRef = useRef(false);
  const api = useApi(process.env.REACT_APP_VAF_BASE_URL);

  useEffect(() => {
    // Only fetch API data when this component first mounts
    if (!mountedRef.current) {
      mountedRef.current = true;

      const { selectedSubjectId } = subjectData || {};
      if (!selectedSubjectId || !centerNumber) return;

      setLoading(true);

      api.get(
        !currentCentreType ? `getDashboardDetails/${centerNumber}/${selectedSubjectId}` : `getConsortiaDashboardDetails/${centerNumber}/${selectedSubjectId}/${currentCentreType}`
      ).then(response => {
       const data = normalizeVisitArrangementStatus(response.data?.data);
      setSubjectData(prev => ({
  ...prev,
  subjectDetails: data[0],
  // Add isRegistered ONLY when centre type is null/empty
  ...((!currentCentreType || currentCentreType.trim() === "") && {
    isRegistered: data[0]?.isCandidateRegistered,
  }),

  // When centre type is Lead → add 3 keys
  ...(currentCentreType === "Lead" && {
    isConsortiaLeadCandidateRegistered:
      data[0]?.isConsortiaLeadCandidateRegistered,
    isConsortiaRestCandidateRegistered:
      data[0]?.isConsortiaRestCandidateRegistered,
    isLeadCandidateRegistered:
      data[0]?.isLeadCandidateRegistered,
  }),

  // When centre type is Rest → add 2 keys
  ...(currentCentreType === "Rest" && {
    isConsortiaRestCandidateRegistered:
      data[0]?.isConsortiaRestCandidateRegistered,
    isRestCandidateRegistered:
      data[0]?.isRestCandidateRegistered,
  }),
}));

      })
        .catch(error => {
          console.error("Error refreshing dashboard details:", error);
        })
        .finally(() => setLoading(false));
    }
    // Don't fetch again on subject change!
  }, []); // Only when page mounts

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <SidePanel />
      <div
        style={{
          marginLeft: "250px", // Prevent overlap
          flex: 1,
          minHeight: "100vh",
          padding: "1rem", // optional
        }}
      >
        <ModerationVisitPanel
          isRegistered={isRegistrationSuccess}
          selectedSubject={selectedSubject}
          selectedSubjectCode={selectedSubjectCode}
        />
      </div>
    </div>
  );
};


export default SubjectDashboardPage;
